import {
    Box, TextField, FormControl, Select,
    MenuItem, InputLabel, Autocomplete, Button,
    CircularProgress, Snackbar, Alert
} from "@mui/material"
import theme from "../../themes/default"
import styles from './style'
import { useFormik } from "formik"
import { useEffect, useState } from "react"
import moment from "moment";
import axios from "axios"


export default function Reports({ onMount, changeTab, categories, onSubmit, isSubmitting, errorMessage }) {

    const [openSnack, setOpenSnack] = useState(true)

    useEffect(() => {
        onMount();
        changeTab(9);
    }, [])

    useEffect(() => {
        setOpenSnack(true)
    }, [errorMessage])


    const handleSnackClose = () => {
        setOpenSnack(false)
    }

    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            category: null,
            status: [],
            tz_num: '',
            fromDate: '',
            toDate: ''


        },
        validate: validateInputs,
        onSubmit: (values) => {
            let data = {};
            if (values.firstName || values.lastName) {
                if (values.firstName && values.lastName) {
                    data = { ...values, name: values.firstName + " " + values.lastName }
                }
                else if (!values.firstName && values.lastName) {
                    data = { ...values, name: values.lastName }
                }
                else if (values.firstName && !values.lastName) {
                    data = { ...values, name: values.firstName }
                }
                delete data['firstName']
                delete data['lastName']
            }
            else {
                data = { ...values }
            }

            let filters = ''
            for (var key in data) {
                if (data[key]) {
                    if (key === "status") {
                        if (data[key].length > 0) {
                            data[key].forEach(function (item) {
                                filters = `${filters}` + `${filters === '' ? '' : '&'}status[]=${item}`
                            })
                        }

                    }
                    else if (key === "category") {
                        filters = `${filters}` + `${filters === '' ? '' : '&'}category=${data[key]["id"]}`
                    }
                    else if (key === "name") {
                        filters = `${filters}` + `${filters === '' ? '' : '&'}name=${data[key]}`
                    }
                    else
                        filters = `${filters}` + `${filters === '' ? '' : '&'}${key}=${data[key]}`
                }
            }
            onSubmit(filters)
        },
    });

    const handleStatusChange = (event) => {
        const {
            target: { value },
        } = event;
        formik.setFieldValue(
            // On autofill we get a stringified value.
            "status", typeof value === 'string' ? value.split(',') : value,
        );
    };


    return (
        <>
            <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                <Box component="p" sx={{ fontSize: "1.4vw", color: theme.palette.text.primary, fontWeight: 700 }}>הצגה וייצוא דו"חות</Box>
                <Box
                    component="form"
                    id="exportCSV"
                    onSubmit={formik.handleSubmit}
                    sx={{
                        width: "100%", p: "2vw", boxSizing: "border-box", display: "flex",
                        justifyContent: "space-between", flexWrap: "wrap"
                    }}>
                    <TextField
                        sx={{
                            ...styles.details,
                            mt: 6,
                            width: "23%"
                        }}
                        id="firstName"
                        name="firstName"
                        variant="outlined"
                        // placeholder={item.name}
                        label="שם פרטי"
                        InputLabelProps={{ shrink: true }}
                        value={formik.values.firstName}
                        onChange={formik.handleChange}
                    />
                    <TextField
                        sx={{
                            ...styles.details,
                            mt: 6,
                            width: "23%"
                        }}
                        id="lastName"
                        name="lastName"
                        variant="outlined"
                        // placeholder={item.name}
                        label="שם משפחה"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        value={formik.values.lastName}
                        onChange={formik.handleChange}
                    />
                    <TextField
                        sx={{
                            ...styles.details,
                            mt: 6,
                            width: "23%"
                        }}
                        id="tz_num"
                        name="tz_num"
                        variant="outlined"
                        // placeholder={item.name}
                        label="תעודת זהות"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        value={formik.values.tz_num}
                        onChange={formik.handleChange}
                        error={formik.touched.tz_num && Boolean(formik.errors.tz_num)}
                        helperText={formik.touched.tz_num && formik.errors.tz_num}
                    />
                    <FormControl
                        sx={{ mt: 6, width: "23%", }}>
                        <InputLabel id="demo-controlled-open-select-label">סטטוס</InputLabel>
                        <Select
                            id="status"
                            name="status"
                            multiple
                            value={formik.values.status}
                            sx={{ backgroundColor: "#ffffff", }}
                            label="סטטוס"
                            onChange={handleStatusChange}
                        >

                            <MenuItem value={0} sx={{ fontSize: "1.2vw" }} disabled>בחירה מהרשימה</MenuItem>
                            <MenuItem value="pending" sx={{ fontSize: "1.2vw" }}>ממתין</MenuItem>
                            <MenuItem value="approved" sx={{ fontSize: "1.2vw" }}>מאושר</MenuItem>
                            <MenuItem value="rejected" sx={{ fontSize: "1.2vw" }}>לא מאושר</MenuItem>
                            <MenuItem value="pending-masav" sx={{ fontSize: "1.2vw" }}>ממתין למס"ב</MenuItem>
                            <MenuItem value="finished" sx={{ fontSize: "1.2vw" }}>הסתיים</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl sx={{ mt: 2, width: "23%" }}>

                        <Autocomplete
                            id="category"
                            name="category"
                            value={formik.values.category}
                            onChange={(e, value) => formik.setFieldValue("category", value)}
                            options={categories}
                            // loading={true}
                            // loadingText="אין אופציות"
                            getOptionLabel={type => type.subject}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            renderInput={(params) => <TextField {...params}
                                label="קטגוריה"
                            />}
                        />
                    </FormControl>
                    <Box sx={{ mt: 2, mr: "auto", ml: "2.5%", width: "30%", display: "flex", justifyContent: "space-between" }} >
                        <TextField
                            sx={{
                                ...styles.details,
                                width: "48%"
                            }}
                            id="fromDate"
                            name="fromDate"
                            variant="outlined"
                            type="date"
                            // placeholder={item.name}
                            label="מתאריך"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            value={formik.values.fromDate}
                            onChange={formik.handleChange}
                            error={formik.touched.fromDate && Boolean(formik.errors.fromDate)}
                            helperText={formik.touched.fromDate && formik.errors.fromDate}
                        />
                        <TextField
                            sx={{
                                ...styles.details,
                                width: "48%"
                            }}
                            id="toDate"
                            name="toDate"
                            variant="outlined"
                            type="date"
                            // placeholder={item.name}
                            label="עד תאריך"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            value={formik.values.toDate}
                            onChange={formik.handleChange}
                            error={formik.touched.toDate && Boolean(formik.errors.toDate)}
                            helperText={formik.touched.toDate && formik.errors.toDate}
                        />
                    </Box>
                </Box>
                <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    form="exportCSV"
                    sx={{ width: "20vw", fontSize: "1.2vw", fontWeight: 600, borderRadius: 0 }}
                >
                    {isSubmitting ? <CircularProgress size={28} sx={{ color: "#ffffff" }} /> : "ייצוא נתונים לקובץ"}

                </Button>
            </Box >
            {errorMessage &&
                (<Snackbar
                    open={openSnack}
                    autoHideDuration={6000}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    onClose={handleSnackClose}>
                    <Alert
                        onClose={handleSnackClose}
                        variant="filled"
                        severity={errorMessage === "אירעה תקלה בלתי צפויה.נסה שנית" ? "error" : "info"}
                        sx={{ width: '100%' }}>
                        {errorMessage}</Alert>

                </Snackbar>)}
        </>
    )
}

const validateInputs = (values) => {
    const errors = {};


    if (values.tz_num && !/^[0-9]*$/.test(values.tz_num)) {
        errors.tz_num = "מספרים בלבד";
    }
    else if (values.tz_num && values.tz_num.length != 9) {
        errors.tz_num = "מס' לא תקין";
    }

    if (values.fromDate && !values.toDate) {
        errors.toDate = "יש להזין תאריך אחרון";
    }
    else if (!values.fromDate && values.toDate) {
        errors.fromDate = "יש להזין תאריך התחלה";
    }
    else if (values.fromDate && values.toDate) {
        if (moment(values.fromDate).isAfter(moment(values.toDate)))
            errors.fromDate = "תאריך התחלה מאוחר מתאריך סיום";
    }

    return errors;
}